export default __webpack_public_path__ + "static/media/shrewdblow3.8fffb0f2.png";